<script setup lang="ts">
import { toastQueue } from '@/composables/baseToast'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { TransitionGroup } from 'vue'
import BaseToastIndividual from './BaseToastIndividual.vue'
</script>

<template>
  <div class="fixed top-4 right-4 z-50 space-y-3">
    <TransitionGroup name="toast" tag="div">
      <BaseToastIndividual
        v-for="toast in toastQueue"
        :key="toast.id"
        :message="toast.message"
        :type="toast.type"
      />
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-from {
  opacity: 0;
  transform: translateY(0.5rem);
}
.toast-enter-active {
  transition: all 300ms ease-out;
}
.toast-leave-to {
  opacity: 0;
  transform: translateY(0.5rem);
}
.toast-leave-active {
  transition: all 300ms ease-in;
}
</style>
